<template>
    <div
        :data-component="$options.name"
        class="hydrated-channel-stage"
        :class="cmsContent.serviceData?.allowAdsBesideStage ? '-hasAdsBesideStage' : ''"
    >
        <div
            class="relative w-full col-start-2 col-end-2 px-16 pt-32 mb-56 screen-m:px-24 screen-l:mb-72 screen-xxl:pt-48"
        >
            <div
                class="absolute inset-0 bottom-56 hydrated-channel-stage__bg screen-l:-left-80 z-background screen-l:-right-80 screen-l:rounded-10 bg-color-brand-beige-100"
            >
                <MsCircle class="absolute top-0 right-0" />
            </div>
            <div class="flex flex-col-reverse justify-between screen-l:flex-row">
                <div>
                    <ms-headline
                        v-if="headline"
                        class="mb-16 screen-l:mb-24 screen-l:mr-24 screen-xxl:max-w-[534px]"
                    >
                        <ms-text :contentTag="headline" />
                    </ms-headline>
                    <ms-text
                        v-if="description && description.text"
                        class="block mb-24 text-h3"
                        :contentTag="description.text"
                    ></ms-text>
                </div>
                <weather-module
                    v-if="cmsContent.serviceData"
                    :weatherServiceData="cmsContent.serviceData.weatherServiceData"
                    class="mb-24 weather-custom-max-w screen-l:basis-1/3 shrink-0 screen-m:mb-32 screen-l:mb-0"
                />
            </div>

            <div class="relative">
                <div
                    ref="teaserContainerRef"
                    class="flex gap-16 p-16 -m-16 overflow-auto screen-m:-m-24 screen-m:p-24 screen-m:overflow-scroll flex-nowrap screen-l:gap-24 scrollbar-hide"
                >
                    <template
                        v-for="channelTeaser in channelTeasers"
                        :key="channelTeaser.cmsId"
                    >
                        <M_ChannelTeaser
                            ref="teaserRefs"
                            class="flex-shrink-0 teaser-custom-width screen-l:flex-shrink"
                            :cmsContent="channelTeaser"
                        ></M_ChannelTeaser>
                    </template>
                    <div
                        v-if="showButtons"
                        data-jest="shadow"
                        :class="showNext ? '-right-24' : '-left-24 rotate-180'"
                        class="absolute bottom-0 h-full w-50 bg-gradient-to-l from-[#FFFFFF80]"
                    />
                    <button
                        v-if="!showNext && showButtons"
                        data-jest="prev"
                        type="button"
                        aria-label="prev"
                        class="absolute p-8 transition-opacity -translate-y-1/2 bg-opacity-50 rounded-full -left-16 top-1/2 bg-color-neutral-black hover:bg-opacity-100"
                        href="#"
                        @click="prev"
                    >
                        <MsChevron class="w-24 h-24 text-white rotate-90" />
                    </button>
                    <button
                        v-if="showNext && showButtons"
                        data-jest="next"
                        type="button"
                        aria-label="next"
                        class="absolute p-8 -translate-y-1/2 bg-opacity-50 rounded-full -right-16 top-1/2 bg-color-neutral-black hover:bg-opacity-100"
                        href="#"
                        @click="next"
                    >
                        <MsChevron class="w-24 h-24 text-white -rotate-90" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" src="./HydratedChannelStage.ts" />
<style scoped lang="scss" src="./HydratedChannelStage.scss" />
